import daily from "@/assets/figma/merchant-home/daily-watermark.svg";
import advertising from "@/assets/figma/merchant-home/advertising-watermark.svg";
import listing from "@/assets/figma/merchant-home/listing-watermark.svg";
import calendar from "@/assets/figma/merchant-home/calendar-watermark.svg";
import media from "@/assets/figma/merchant-home/media-watermark.svg";
import competitor from "@/assets/figma/merchant-home/competitor-watermark.svg";
import creator from "@/assets/figma/merchant-home/creator-watermark.svg";
import trends from "@/assets/figma/merchant-home/trend-watermark.svg";
import type { WorkbenchCardType } from "./contentSchemas";

export const workbenchWatermarks: Record<WorkbenchCardType, string> = {
	daily_product: daily,
	advertising_content: advertising,
	auto_listing: listing,
	promotion_calendar: calendar,
	media_reference: media,
	competitor_updates: competitor,
	creator_tracking: creator,
	market_trends: trends,
	monthly_opportunity: daily,
	store_opening: listing,
	pricing_calculator: trends,
	product_selection_analysis: daily,
	creator_recommendation: creator,
	report_export: media,
	content_strategy: advertising,
	policy_compliance: calendar,
	store_operations: trends,
	product_performance: daily,
	product_diagnosis: competitor,
	advertising_management: advertising,
	advertising_performance: advertising,
	inventory_management: listing,
	fulfillment_logistics: listing,
	after_sales_reviews: competitor,
	profit_settlement: trends,
	social_media: creator,
	email_management: media,
};
